import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  businessUnitsKeys,
  RequestTypes,
} from '@core/react-query/features/businessUnits'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'

export const useUpdateBusinessUnit = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['updateBusinessUnit']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...businessUnitsKeys.updateBusinessUnit,
    retry: 0,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessUnitsKeys._def })
      queryClient.invalidateQueries({
        queryKey: profileKeys.getUserStats._def,
      })
    },
  })
}
